


















import { map } from 'lodash';

import { PEOPLE_QUERY } from '@/components/zen_objects_dropdown/graphql/queries';
import ZenObjectsDropdown from '@/components/zen_objects_dropdown/ZenObjectsDropdown.vue';

import { filterPresenterMixin } from './common';

export const emailsToFilter = (emails: string[]) => {
  const filter = {
    left: 'email',
    op: {
      name: 'in_array',
    },
    right: emails,
  };

  return JSON.stringify(filter);
};

export default {
  name: 'PeopleFilterAttributePresenter',
  components: {
    ZenObjectsDropdown,
  },
  props: {
    ...filterPresenterMixin.props,
  },
  computed: {
    internalValue(): string {
      if (!this.preselectedObjects) return '';

      return map(this.preselectedObjects.edges, o => o.node.id);
    },
  },
  methods: {
    onObjectChange(object): void {
      this.$emit('input', object.email);
    },
  },
  apollo: {
    preselectedObjects: {
      // TODO: during dev only, remove
      fetchPolicy: 'network-only',

      query() {
        return PEOPLE_QUERY;
      },
      variables() {
        return {
          objectType: 'Person',
          pageSize: 1000, // give it all at once
          page: 1,
          order: { by: 'name', direction: 'ASC' },
          filter: emailsToFilter([this.value]),
        };
      },
      update(data) {
        return data.objects;
      },
    },
  },
};
